export const ADD_TO_CART = "ADD_TO_CART";

export const REMOVE_CART = 'REMOVE_CART';

export const GET_CARTITEMS = 'GET_CARTITEMS';

export const GET_NUMBER = 'GET_NUMBER';

export const TOGGLE_QTY = "TOGGLE_QTY";
